// Detect if running in native app vs web
export const isNativeApp = () => {
  return window.Capacitor !== undefined && window.Capacitor.isNativePlatform();
};

// API base URL - use Heroku backend in native app
export const getApiBaseUrl = () => {
  // Native app uses the Heroku URL
  if (isNativeApp()) {
    return 'https://infinite-hamlet-24207-66d47cc01144.herokuapp.com';
  }
  
 
  return window.location.origin;
};

// Force app identifier for native
export const getAppIdentifier = () => {
  if (isNativeApp()) {
    return 'nidoux';
  }
  return undefined;
};